import * as ViewModels from "./ViewModels/index.js";
import * as Globalization from "./Globalization/index.js";
import * as Enums from "./Enums/index.js";
/** CoStar.Api.PropertyComps.CompSource */
export var CompSource;
(function (CompSource) {
    CompSource[CompSource["Unknown"] = 0] = "Unknown";
    CompSource[CompSource["Collaboration"] = 2] = "Collaboration";
    CompSource[CompSource["Radius"] = 3] = "Radius";
    CompSource[CompSource["Custom"] = 4] = "Custom";
    CompSource[CompSource["Linked"] = 5] = "Linked";
})(CompSource || (CompSource = {}));
export { ViewModels, Globalization, Enums };
